import { AnalyticUtility } from '@ff/ui/utils/analyticUtils';
import getRegion from 'shared/lib/getRegion';

const region = typeof window !== 'undefined' ? getRegion(window.location.href) : 'US';
const analytics = new AnalyticUtility(region);

export default analytics;